// Design tokens + shared color/tone maps used across the whole UI.
// NOTE: `AG` is intentionally a mutable singleton — AugmentHR does
// `Object.assign(AG, tokens)` at runtime so theme changes (color presets,
// light/dark) propagate to every module that imports this same reference.

export const FONT = "'Inter', ui-sans-serif, system-ui, sans-serif";

export const AG = {
  primary: '#DC0069',
  primaryLightest: '#FCE8F0',
  primaryLight: '#F8B3D1',
  primaryDark: '#9A0048',
  primaryDarkest: '#5A002A',
  n50: '#F8F9FA',
  n100: '#F3F4F6',
  n200: '#E5E7EB',
  n300: '#D2D6DB',
  n400: '#9DA4AE',
  n500: '#6C737F',
  n600: '#4D5761',
  n700: '#2F3746',
  n800: '#1C2536',
  n900: '#111927',
  success: '#10B981',
  successDark: '#0B815A',
  warning: '#F79009',
  warningDark: '#B54708',
  error: '#F04438',
  errorDark: '#B42318',
  info: '#06AED4',
  infoDark: '#0E7090',
  purple: '#9E77ED',
  purpleLightest: '#F9F5FF',
  purpleDark: '#6941C6',
  blue: '#2970FF',
  text: '#111927',
  textSec: '#6C737F',
  divider: '#F2F4F7',
  paper: '#FFFFFF',
  bg: '#F8F9FA',
};

// Mutated in place by syncTokens() so the same imported reference reflects the
// active brand everywhere (recharts reads PIE_COLORS[i] at render).
export const PIE_COLORS = [AG.primary, AG.info, AG.warning, AG.purple, AG.n400];

export const STATUS_COLOR = {
  Active: AG.success,
  Probation: AG.warning,
  'On Notice': AG.error,
  Inactive: AG.n400,
};

// Single entry point for runtime theme changes (brand / preset / light-dark).
// Refreshes the AG singleton and the derived colour maps without breaking the
// imported references.
export function syncTokens(tokens, pieColors) {
  Object.assign(AG, tokens);
  if (Array.isArray(pieColors)) {
    PIE_COLORS.splice(0, PIE_COLORS.length, ...pieColors);
  }
  Object.assign(STATUS_COLOR, {
    Active: AG.success,
    Probation: AG.warning,
    'On Notice': AG.error,
    Inactive: AG.n400,
  });
}

export const statusTone = (s) =>
  ({
    Active: 'success',
    Probation: 'warning',
    'On Notice': 'error',
    Approved: 'success',
    Pending: 'warning',
    'Pending Manager': 'warning',
    'Pending HR': 'info',
    Rejected: 'error',
    Paid: 'success',
    Present: 'success',
    Late: 'warning',
    Absent: 'error',
  })[s] || 'neutral';
